/**
 * @generated SignedSource<<9de53f8e76e4b15dd2de718cb012e5b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NoteFinderPageOverlayTie_Tie$data = {
  readonly start_x: number;
  readonly start_y: number;
  readonly end_x: number;
  readonly end_y: number;
  readonly id: string;
  readonly " $fragmentType": "NoteFinderPageOverlayTie_Tie";
};
export type NoteFinderPageOverlayTie_Tie$key = {
  readonly " $data"?: NoteFinderPageOverlayTie_Tie$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageOverlayTie_Tie">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteFinderPageOverlayTie_Tie",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start_x",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start_y",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "end_x",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "end_y",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "MusicParseStepDataTieFinderTie",
  "abstractKey": null
};

(node as any).hash = "b185fc4974fb6b08c7a1c436911836e0";

export default node;
